/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PointsStrictHttpResponse } from '../../points-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfilePointsHistoryRequest } from '../../models/profile-points-history-request';
import { ProfilePointsHistoryResponse } from '../../models/profile-points-history-response';

export interface ConsumerHistoryPost$Params {
  
    /**
     * The points history request containing date range filters.
     */
    body?: ProfilePointsHistoryRequest
}

export function consumerHistoryPost(http: HttpClient, rootUrl: string, params?: ConsumerHistoryPost$Params, context?: HttpContext): Observable<PointsStrictHttpResponse<ProfilePointsHistoryResponse>> {
  const rb = new RequestBuilder(rootUrl, consumerHistoryPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PointsStrictHttpResponse<ProfilePointsHistoryResponse>;
    })
  );
}

consumerHistoryPost.PATH = '/Consumer/History';
